import React, { createRef } from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../../Shared/Icon/Icon'

const RecentContacts = ({
  contacts, onLoadMore, onSearchQueryChange, onUsernameChange, selectedUsername,
}) => {
  const classNameForContact = (value) => {
    return `section__item ${(selectedUsername === value ? ' is-active' : '')}`
  }

  const onSearchSubmit = e => {
    e.preventDefault()

    onSearchQueryChange(input.current.value)
  }

  const input = createRef()

  return (
    <div>
      <div className="search-form section__item--contacts-search">
        <form onSubmit={onSearchSubmit}>
          <Icon type="search" />
          <input
            autoComplete="off"
            className="contacts-search__field"
            placeholder="search"
            type="search"
            ref={input}
          />
        </form>
      </div>
      {
        contacts.data.map((contact) => (
          <div
            key={contact.id}
            className={classNameForContact(contact.attributes.username)}
            onClick={onUsernameChange}
            value={contact.attributes.username}
          >
            {contact.attributes.username}
          </div>
        ))
      }
      {
        contacts.meta.totalPages > contacts.meta.currentPage
        && (
        <div className="section__footer u-text-center">
          <span onClick={onLoadMore}>Load more</span>
        </div>
        )
      }
    </div>
  )
}

RecentContacts.propTypes = {
  contacts: PropTypes.shape({
    data: PropTypes.array.isRequired,
    meta: PropTypes.shape({
      totalPages: PropTypes.number.isRequired,
      currentPage: PropTypes.number.isRequired,
    }),
  }).isRequired,
  onLoadMore: PropTypes.func.isRequired,
  onSearchQueryChange: PropTypes.func.isRequired,
  onUsernameChange: PropTypes.func.isRequired,
  selectedUsername: PropTypes.string,
}

RecentContacts.defaultPropTypes = {
  selectedUsername: '',
}

export default RecentContacts
